// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__CW1s2","label":"Labeled_label__37Sft","divider":"Labeled_divider__2lVf1"};